// Production-safe logger utility for client-side
// Only logs in development mode

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  // Debug logs - only in development
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  // Info logs - only in development
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  // Warnings - always log
  warn: (...args) => {
    console.warn(...args);
  },
  
  // Errors - always log (important for production debugging)
  error: (...args) => {
    console.error(...args);
  },
  
  // Debug - only in development
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  }
};

export default logger;
